import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  fdeNewSecurityObject
} from "../../../common/it-interface";
import {SIDE_NAV_TITLES} from "../../../common/it-constants";
import {convertToSnakeCase} from "../../../common/it-utils";
import { FdeDeoDistributorService } from "../../eod-distributor.service";

@Component({
  selector: 'app-new-security',
  templateUrl: './new-security.component.html',
  styleUrls: ['./new-security.component.scss']
})
export class NewSecurityComponent implements OnInit {
  @Output() titleHeading = new EventEmitter<string>();
  @Output() shouldDisplayTitle = new EventEmitter<boolean>();
  @Output() fdeNewSecurities = [];
  @Output() fdeNewSecurityDetail = [];

  @ViewChild('footer') footer: any

  pageTitle: string = SIDE_NAV_TITLES.newSecurity;
  loading = true;
  showAlertPopup = false;
  message: string;

  newSecurityKey = convertToSnakeCase(SIDE_NAV_TITLES.newSecurity);

  constructor(private fdeDeoDistributorService: FdeDeoDistributorService) { }

  ngOnInit() {
    this.titleHeading.emit(this.pageTitle);
    this.shouldDisplayTitle.emit(false);
    this.getLists();
  }

  getLists() {
    this.getNewSecurities();
  }

  // api function call to get list of new security
  getNewSecurities() {
    this.loading = true;
    this.fdeDeoDistributorService.fdeNewSecuritiesQuery('', '').then(response => {
      if (response['status'] && response['status'] === 200 && response['data'] != null) {
        this.fdeNewSecurities = response['data'];
        this.loading = false;
      } else {
        this.loading = false;
        this.fdeNewSecurities = [];
        this.showWarningPopup('Records not found');
      }
    }).catch(err => {
      this.showWarningPopup('Records not found');
      this.loading = false;
      this.fdeNewSecurities = [];
    });
  }

  // api function call to get list of new security detail
  getNewSecurityDetail(fundId, ticker, tickerType) {
    this.loading = true;
    this.fdeDeoDistributorService.fdeNewSecurityDetailQuery(fundId, ticker, tickerType).then(response => {
      if (response['status'] && response['status'] === 200 && response['data'] != null) {
        this.fdeNewSecurityDetail = response['data'];
        this.loading = false;
      } else {
        this.showWarningPopup('Records not found');
        this.fdeNewSecurityDetail = [];
        this.loading = false;
      }
    }).catch(err => {
      // this.showWarningPopup('Records not found');
      this.fdeNewSecurityDetail = [];
      this.loading = false;
    });
  }

  selectRow(e) {
    const fundId = e.fundId;
    const ticker = e.id;
    const tickerType = e.tickerType;
    if (fundId != null && ticker != null && tickerType != null) {
       this.getNewSecurityDetail(fundId, ticker, tickerType);
    } else {
      this.fdeNewSecurityDetail = [];
    }
  }

  showWarningPopup(message) {
    this.showAlertPopup = true;
    this.message = message;
  }
}
